import { Link } from 'react-router-dom';

export default function Article1() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <Link to="/blog" className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900 mb-4 cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Blog
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mt-2 leading-tight">Wall-Mounted TVs vs Entertainment Units: Pros and Cons</h1>
          <time className="text-sm text-gray-500 mt-4 block">May 15, 2024</time>
        </div>
      </header>

      {/* Article Content */}
      <main className="max-w-3xl mx-auto px-6 py-12">
        <article className="prose prose-lg max-w-none">
          {/* Featured Image */}
          <div className="w-full h-96 mb-10 rounded-lg overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/5fa26eaae62e4bdf517c706306a01c46.jpg"
              alt="Wall-mounted TV vs entertainment unit comparison"
              title="Wall-mounted TV vs entertainment unit comparison"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <p className="text-lg leading-relaxed text-gray-800">
            Choosing between a wall-mounted TV and a traditional entertainment unit often depends on space, layout, and how the room is used day to day. Both options offer advantages, but they serve different priorities in modern homes.
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            Wall-mounted TVs create a cleaner, more open feel by removing bulky furniture and freeing up floor space. This approach suits smaller rooms and open-plan living areas where visual simplicity matters. Mounting also allows the screen to be positioned at an optimal viewing height.
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            Entertainment units, by comparison, provide built-in storage and easy access to devices. They can be practical in rooms where additional shelving is needed, but they often take up more space and limit furniture placement.
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            Examples of wall-mounted TV services listed within local government directories can be viewed at: <a href="https://www.wyndham.vic.gov.au/directory/tv-wall-mounting-melbourne" className="text-gray-900 underline hover:text-gray-700 cursor-pointer break-all">https://www.wyndham.vic.gov.au/directory/tv-wall-mounting-melbourne</a>
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            For national guidance on building standards and construction considerations, information published by the <a href="https://www.abcb.gov.au/" target="_blank" rel="noopener noreferrer" className="text-gray-900 underline hover:text-gray-700 cursor-pointer">Australian Building Codes Board</a> provides useful background.
          </p>

          {/* Embedded Reference */}
          <div className="my-10 border border-gray-200 rounded-lg overflow-hidden">
            <iframe 
              src="https://docs.google.com/document/d/e/2PACX-1vRuBGoEWNW1Kg5E555iCjHGRi_zP1GEKyoJwH5LKQ6MAqPY9NxY3O8yS8myMWmddgqfR86ssphb05-X/pub?embedded=true"
              className="w-full h-96"
              title="Embedded reference document"
            ></iframe>
          </div>
        </article>

        {/* Navigation */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <Link 
            to="/blog"
            className="inline-flex items-center text-sm font-medium text-gray-900 hover:text-gray-700 cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Back to all articles
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-20">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
            <p>&copy; 2024 Wall Setup &amp; Home Installations. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mt-4 md:mt-0 hover:text-gray-900 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
